/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Manage_UploadInputs */

const cs_templates_manage_upload = /** @type {(inputs: Templates_Manage_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát .typ`)
};

const en_templates_manage_upload = /** @type {(inputs: Templates_Manage_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload .typ`)
};

/**
* | output |
* | --- |
* | "Upload .typ" |
*
* @param {Templates_Manage_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_manage_upload = /** @type {((inputs?: Templates_Manage_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Manage_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_manage_upload(inputs)
	return cs_templates_manage_upload(inputs)
});